module.exports = __webpack_public_path__ + "static/media/MIC.c5cf7d2f.svg";